import React from 'react';
import {
  IconDataflow,
  IconTerminal,
  IconShieldTick,
  IconBankNote,
  IconDashboard,
  IconMail,
  IconSupport,
  IconMenu,
  IconAdd,
  IconSites,
  IconAiPencil,
  IconStarMoving,
  IconTools,
  IconN8N,
  IconRobot,
  IconClock,
  IconChatCheck,
  IconMegaphone,
  IconBag,
  IconOpenClaw,
  IconQuestion,
  IconBlogRight,
  IconPlayer,
  IconShield,
  IconLink,
  IconDomain,
  IconServer,
  IconClockCheck,
  IconStarsBright,
  IconPaint,
} from 'gatorcomponents';
import VpsN8nImage from '@/pages/Home/media/vps-n8n.png';
import VpsOpenClawImage from '@/pages/Home/media/vps-open-claw.png';
import WordPressAIImage from '@/pages/Home/media/wordpress-ai-es.png';
import SiteBuilderV2Image from '@/pages/Home/media/site-builder-v2-es.png';
import EmailTitanImage from '@/pages/Home/media/email-titan.png';
import AiAgentsImage from '@/pages/Home/media/ai-agents.png';
import { PRODUCTS_HIGHLIGHT_IDS } from '../../pages/Home/HomeHandler.enum';
import { COUNTRY, SITE_HG } from '@/config';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import { HOSTING_URL } from '@/config/urls/hostingUrls';
import { REGISTER_DOMAIN_URL } from '@/config/urls/domainsUrls';

const n8nPrices = {
  mx: 62.00,
  co: 14250.00,
  cl: 3490.00,
  ar: 3239.49,
  pe: 14.49,
  do: 214.19,
  ec: 3.99,
  uy: 142.99,
  bo: 24.99,
};
const n8nPrice = n8nPrices[COUNTRY.toLowerCase()];

export default {
  aiConversationBanner: {
    betaTag: 'Beta',
    title: (name = '') => `Hola, ${name}. ¡Dime qué quieres hacer!`,
    input: {
      placeholderAlreadyOpened: 'Ya tienes un chat abierto con el Gator',
      placeholder: 'Pregunta o pídele al Gator que haga algo...',
    },
    audio: {
      recordingLabel: 'Escuchando...',
      transcribingLabel: 'Generando Transcripción...',
    },
    suggestions: [
      {
        Icon: IconDashboard,
        id: 'create-site',
        label: 'Crear sitio',
        initialMessage: 'Ayúdame a crear un nuevo sitio web',
        action: 'newSite',
        value: OPTIONS.CREATE_SITE,
      },
      {
        Icon: IconMail,
        id: 'create-email',
        label: 'Crear correo',
        initialMessage: 'Ayúdame a crear un correo profesional',
        action: 'email',
        value: OPTIONS.CREATE_EMAIL,
      },
      {
        Icon: IconAdd,
        id: 'contract-domain',
        label: 'Contratar dominio',
        initialMessage: 'Quiero contratar un dominio',
        value: OPTIONS.DOMAIN_PURCHASE,
      },
      {
        Icon: IconStarMoving,
        id: 'marketing-tips',
        label: 'Marketing',
        initialMessage: 'Enumera las formas en las que puedes ayudarme con marketing',
        value: OPTIONS.MARKETING_TIPS,
        hidden: true,
      },
      {
        Icon: IconSupport,
        id: 'support',
        label: 'Soporte',
        initialMessage: 'Necesito apoyo',
        value: OPTIONS.SUPPORT,
      },
      {
        Icon: IconMenu,
        id: 'more',
        label: 'Más',
        action: 'expand',
        value: OPTIONS.MORE,
      },
      {
        Icon: IconSites,
        hideOnInit: true,
        id: 'configure-domain',
        label: 'Configurar dominio (DNS)',
        initialMessage: 'Configura mi dominio',
        action: 'domainConfig',
        value: OPTIONS.CONFIGURE_DOMAIN,
      },
      {
        Icon: IconTools,
        hideOnInit: true,
        id: 'check-account',
        label: 'Revisar mi cuenta',
        initialMessage: 'Haz un diagnóstico de mi cuenta',
        value: OPTIONS.CHECK_ACCOUNT,
      },
      {
        Icon: IconAiPencil,
        hideOnInit: true,
        id: 'create-posts',
        label: 'Crear publicaciones',
        initialMessage: 'Ayúdame a crear mensajes para publicaciones en redes sociales',
        value: OPTIONS.CREATE_POSTS,
      },
      {
        Icon: IconBag,
        hideOnInit: true,
        id: 'contract-product',
        label: 'Contratar producto',
        initialMessage: 'Quiero contratar un nuevo producto',
      },
    ],
  },
  greetingBanner: {
    title: (name = '') => (
      <>
        ¡Hola,
        {' '}
        <strong>{name}</strong>
        !
      </>
    ),
    subtitle: '¡Qué bueno tenerte por aquí!',
    cta: {
      label: 'Crear sitio web',
      link: '/sitios-web/crear-sitio-web',
    },
  },
  bannerAiAgent: {
    popover: {
      title: 'Soy una Inteligencia Artificial',
      description: 'Hago que tu sitio web esté listo en un momento. ¿Quieres ver lo fácil que es?',
      buttonLabel: 'Entendí',
    },
  },
  VinculedGoogle: {
    title: '¡Éxito al vincular tu cuenta con Google!',
    message: 'Ahora puedes iniciar sesión con tu usuario y contraseña o directamente a través de Google',
  },
  ContractedProducts: {
    hosting: {
      title: 'Hosting',
      buttonGoToLabel: 'Ir a Hosting',
      empty: {
        title: '¡Hospede su sitio con calidad y conquiste el mundo digital!',
        subtitle: 'Elija un alojamiento confiable y lleve su negocio al siguiente nivel.',
        buttonLabel: 'Contratar hosting',
      },
    },
    domain: {
      title: 'Dominios',
      buttonGoToLabel: 'Ir al dominio',
      empty: {
        title: '¡Asegure su dominio ahora y destaque su marca online!',
        subtitle: 'Registre su dominio ahora y lleve su negocio al siguiente nivel.',
        buttonLabel: 'Contratar dominio',
      },
    },
    buttonLabelManage: 'Administrar',
    expiresOn: 'Expira en',
    hostingStatus: {
      pending: 'Pendiente',
      active: 'Activo',
      completed: 'Completo',
      suspended: 'Suspendido',
      terminated: 'Cerrado',
      cancelled: 'Cerrado',
      fraud: 'Fraude',
      building: 'En Configuración',
      activationPending: 'Esperando activación',
    },
  },
  infosMenuHighlight: {
    tagNew: 'Nuevo',
    studioGuide: {
      title: 'Conozca HostGator Studio',
      description: 'Aproveche la funcionalidad de Studio para crear contenidos gratis para su negocio.',
    },
    staticHighlights: [
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_BUILDER,
        size: 100,
        name: 'HostGator Builder',
        title: 'Creador de sitios',
        subtitle: 'Llegó el nuevo Creador de sitios con IA',
        description: 'Sin códigos. Sin complicaciones. Solo resultados. Tú hablas, la IA lo crea. ¿Tu negocio online? ¡Solo aquí!',
        link: '/sitios-web/crear-sitio-web',
        image: SiteBuilderV2Image,
        cta: 'Quiero mi sitio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crear sitio Web',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
        size: 100,
        name: 'HighLightProduct',
        title: 'WordPress',
        subtitle: 'ES: ¡Tenga un sitio listo para vender más!',
        description: 'Nuestro WordPress con IA lo hace todo por usted: textos, imágenes, diseño, ¡sin complicaciones! Solo necesita modificarlo si lo desea.',
        link: '/sitios-web/crear-sitio-web',
        image: WordPressAIImage,
        cta: 'Quiero mi sitio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crear sitio web',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
        size: 100,
        name: 'HighLightProduct',
        title: 'Correo Titan',
        subtitle: '¡Ten un correo con el nombre de tu marca!',
        description: 'Gana la confianza de tus clientes. Crea cuentas para cada equipo y agenda reuniones con calendario.',
        tag_color: '#FFCF00',
        link: 'open_merlin',
        image: EmailTitanImage,
        cta: 'Crear correo',
        link_open_behavior: 'function',
        menu: {
          title: 'Correo Profesional',
          icon: <IconMail color="primaryExtraDark" />,
        },
      },
      {
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.AI_AGENTS,
        size: 100,
        name: 'Agentes de IA',
        subtitle: 'Sólo en Creador de Sitios: ¡aprovecha ahora!',
        title: 'Ten un agente de IA que atienda por ti',
        badge: 'Gratis en tu plan',
        image: AiAgentsImage,
        cta: 'Quiero mi agente',
        descriptionList: [
          {
            icon: <IconChatCheck color="lowPure" />,
            text: 'Responder dudas en segundos;',
            id: 'reply',
          },
          {
            icon: <IconMegaphone color="lowPure" />,
            text: 'Presentar tus productos y servicios;',
            id: 'show_products',
          },
          {
            icon: <IconClock color="lowPure" />,
            text: 'Servicio 24 horas',
            id: '24_hours_support',
          },
        ],
        menu: {
          title: 'Crea tu Agente de IA',
          icon: <IconRobot color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_N8N,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS n8n',
        description: 'Crea y ejecuta tus automatizaciones en minutos',
        descriptionPrefix: (price = n8nPrice) => `desde ${formatCurrency(price)}/mes`,
        descriptionList: [
          {
            icon: <IconDataflow color="lowPure" />,
            text: 'Flujos de trabajo e integraciones ilimitadas',
            id: 'dataflow',
          },
          {
            icon: <IconTerminal color="lowPure" />,
            text: 'Acceso root y libertad total para personalizar',
            id: 'terminal',
          },
          {
            icon: <IconShieldTick color="lowPure" />,
            text: 'Entorno aislado y confiable',
            id: 'shield',
          },
          {
            icon: <IconBankNote color="lowPure" />,
            text: 'Sin cobros por tareas ni límites de uso',
            id: 'banknote',
          },
        ],
        link: '/sitios-web/crear-sitio-web',
        image: VpsN8nImage,
        cta: 'Conocer VPS n8n',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Servidor VPS n8n',
          icon: <IconN8N color="primaryExtraDark" />,
        },
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_OPEN_CLAW,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS OpenClaw',
        subtitle: (
          <>
            Coloca un
            {' '}
            <span>agente de IA</span>
            {' '}
            para actuar por ti
          </>
        ),
        description: 'Automatiza tareas, integra plataformas y reduce el trabajo manual. El OpenClaw ejecuta procesos de forma autónoma y trabaja continuamente para ti en tu día a día.',
        link: `${SITE_HG}/vps-hosting/openclaw`,
        image: VpsOpenClawImage,
        cta: 'Conocer VPS OpenClaw',
        link_open_behavior: 'new_tab',
        menu: {
          title: 'Servidor VPS OpenClaw',
          icon: <IconOpenClaw color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
    ],
  },
  infosLoadingError: {
    buttonLabel: 'Recargar Página',
    message: (
      <>
        Ocurrió un error al cargar la página
        {' '}
        <br />
        Si persiste, intente nuevamente más tarde.
      </>
    ),
  },
  v2: {
    banner: {
      title: 'Temos tudo que você precisa para acelerar seu negócio:',
      listTitle: 'Seu site criado com IA',
      list: [
        { text: 'Em minutos, o site do seu negócio pronto, hoje', icon: <IconClockCheck color="primaryExtraDark" /> },
        { text: 'Diga como quer e nossa IA faz tudo', icon: <IconStarsBright color="primaryExtraDark" /> },
        { text: 'Seu site com cores, design, textos e muito mais', icon: <IconPaint color="primaryExtraDark" /> },
      ],
      cta: 'Criar site com IA',
    },
    readyProductsCarousel: {
      title: 'Produtos prontos para você usar e fazer seu negócio acontecer',
      description: 'Cada solução ajuda o seu negócio a ser encontrado e a gerar resultados mais rápidos online.',
      email: {
        id: 'email',
        title: 'Criar e-mail',
        description: 'Quer a confiança dos seus clientes? Tenha um e-mail profissional.',
        icon: <IconMail color="primaryMedium" />,
        cta: 'Criar e-mail',
      },
      linkInBio: {
        id: 'linkInBio',
        title: 'Link na Bio',
        description: 'Tenha um link com todos os acessos do seu site, contatos e redes sociais.',
        icon: <IconLink color="primaryMedium" />,
        cta: 'Criar Link na Bio',
      },
      createAgent: {
        id: 'createAgent',
        title: 'Criar Agente',
        description: 'Seu cliente sempre atendido no site e WhatsApp por seu Agente de IA.',
        icon: <IconRobot color="primaryMedium" />,
        cta: 'Criar Agente de IA',
      },
      marketing: {
        id: 'marketing',
        title: 'Agente de Marketing',
        description: 'Crie anúncios que vendem. Turbine seus posts e se destaque.',
        icon: <IconMegaphone color="primaryMedium" />,
        cta: 'Criar Agente de Marketing',
      },
      monarx: {
        id: 'monarx',
        title: 'Monarx',
        description: 'Proteja seu site contra ameaças e mantenha tudo seguro.',
        icon: <IconShield color="primaryMedium" />,
        cta: 'Adquirir Monarx',
      },
      domain: {
        id: 'buyDomain',
        title: 'Domínio adicional',
        description: 'Ganhe mais alcance com um segundo domínio para divulgar seu site.',
        icon: <IconDomain color="primaryMedium" />,
        cta: 'Adquirir domínio',
      },
    },
    activeProductsCarousel: {
      title: 'Seus produtos ativos',
      hosting: {
        id: 'hosting',
        title: 'Hospedagem',
        icon: <IconServer color="primaryMedium" />,
      },
      domain: {
        id: 'domain',
        title: 'Domínio',
        icon: <IconDomain color="primaryMedium" />,
      },
      site: {
        id: 'site',
        title: 'Meu site',
        icon: <IconDashboard color="primaryMedium" />,
      },
      email: {
        id: 'email',
        title: 'Meu e-mail',
        icon: <IconMail color="primaryMedium" />,
      },
      linkInBio: {
        id: 'linkInBio',
        title: 'Link na Bio',
        icon: <IconLink color="primaryMedium" />,
      },
      createAgent: {
        id: 'createAgent',
        title: 'Criar Agente',
        icon: <IconRobot color="primaryMedium" />,
      },
      marketing: {
        id: 'marketing',
        title: 'Agente de Marketing',
        icon: <IconMegaphone color="primaryMedium" />,
      },
      monarx: {
        id: 'monarx',
        title: 'Monarx',
        icon: <IconShield color="primaryMedium" />,
      },
    },
    getUsedToTitle: 'Fique por dentro!',
    cardsGetUsedTo: [
      {
        id: 'courses',
        icon: <IconPlayer color="primaryBlue" />,
        title: 'Cursos gratuítos com certificados',
        description: 'Aprende com especialistas a transformar seu negócio em presença digital.',
        cta: 'Acessar',
      },
      {
        id: 'blog',
        icon: <IconBlogRight color="primaryBlue" />,
        title: 'HostGator Blog',
        description: 'Dicas, instruções e tutoriais imperdíveis.',
        cta: 'Acessar',
      },
      {
        id: 'help',
        icon: <IconQuestion color="primaryBlue" />,
        title: 'Central de ajuda',
        description: 'Tem algum dúvida? A gente te ajuda!',
        cta: 'Acessar',
      },
    ],
    emptyProducts: {
      title: 'La mejor hospedaje y dominio para tu sitio web',
      items: [
        {
          id: 'hosting',
          icon: <IconServer color="primaryBlue" size="sm" />,
          title: 'Hospeda tu sitio web',
          description: 'Seguridad total, preparada para soportar picos de acceso y mantener tu sitio web siempre disponible.',
          cta: 'Hospedar mi sitio web',
          link: HOSTING_URL,
        },
        {
          id: 'domain',
          icon: <IconSites color="primaryBlue" size="sm" />,
          title: 'Garanta tu dominio',
          description: 'Registra tu dominio ahora y comienza a destacar el nombre de tu negocio online.',
          cta: 'Registrar mi dominio',
          link: REGISTER_DOMAIN_URL,
        },
      ],
    },
  },
};
